<template>
    <div>
        <el-date-picker v-model="date" type="date" :placeholder="config.placeholder" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" clearable>
        </el-date-picker>
    </div>
</template>

<script>
export default {
    name: 'FromDate',
    components: {},
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        date(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.date = value
        }
    },
    data() {
        return {
            date: this.value,
        }
    },
    methods: {

    }
}
</script>
